import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function getRangeCommissionMonth(rowId) {
    const response =  axios.get(MONTHLY_COMMISSIONS_ENDPOINT + `/getValidPeriodRange/${rowId}`);
    return response
}